export const myProjects = [
  {
    uniqueID: "1",
    name: "Condos.ca",
    logo: "https://hq.property.ca/static/logo/condos-logo.png",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/condos-ss1.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/condos-ss2.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/condos-ss3.png",
    ],
    description:
      "Condos.ca is the Greater Toronto Area’s leading, data-driven platform focused exclusively on the condominium market. It provides unparalleled transparency by giving users direct access to crucial market intelligence, including historical sold prices, rental data, and detailed price-per-square-foot analysis for specific buildings. Serving over one million registered users, Condos.ca empowers buyers and investors to evaluate vertical communities with confidence using advanced filters and comprehensive building performance reports.",
    tags: ["ReactJS"],
    liveLink: "https://condos.ca/",
  },
  {
    uniqueID: "2",
    name: "Property.ca",
    logo: "https://hq.property.ca/static/logo/property-logo.png",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/property-ss2.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/property-ss1.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/property-ss3.png",
    ],
    description:
      "Property.ca is the flagship real estate portal for the Property.ca Inc. Brokerage, offering a complete view of the entire residential market, including freehold houses, townhomes, and condominiums. It brings the company's trademark data transparency—such as public access to sold history and neighborhood trend analysis—to all housing segments. Property.ca is the essential destination for all buyers and sellers, connecting millions of monthly users with a full-service, tech-forward brokerage and its team of dedicated agents.",
    tags: ["ReactJS"],
    liveLink: "https://property.ca/",
  },
  {
    uniqueID: "3",
    name: "mrLoft.ca",
    logo: "https://hq.property.ca/static/logo/mrloft-logo.png",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/mrLoft-ss2.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/mrLoft-ss1.png",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/mrLoft-ss3.png",
    ],
    description:
      "MrLoft.ca is the highly specialized property portal dedicated to the Toronto loft market, focusing exclusively on unique architectural properties like hard lofts and character conversions. It serves a niche audience by curating highly targeted inventory and providing unique tools that highlight historic details, custom layouts, and neighbourhood-specific data. MrLoft.ca ensures a superior search experience for design-conscious buyers and renters seeking properties beyond the traditional condo or house mold.",
    tags: ["ReactJS"],
    liveLink: "https://mrloft.ca/",
  },
  {
    uniqueID: "3",
    name: "N-YouTube",
    logo: "https://n-youtube.netlify.app/yt_logo_rgb_light.png",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss2.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss3.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss4.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss5.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss6.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss7.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/nYoutube-ss8.webp",
    ],
    description:
      "n-youtube is a ReactJS-based web app that replicates core YouTube functionalities. It features top video listings from the YouTube API, a customizable day/night mode, a debounced search bar with suggestions, and a detailed watch page with infinite nested comments and a live chat simulation. Built with React, Redux, and Tailwind CSS, it is hosted on Netlify and optimized for large screens.",
    tags: [
      "ReactJS",
      "Redux Toolkit",
      "Tailwind CSS",
      "React-Icons",
      "YouTube Public API",
      "Netlify",
      "Day/Night Mode",
      "Higher-Order Components",
      "Debouncing",
      "Infinite Nested Comments",
      "Live Chat",
      "React Hooks",
      "React Router DOM",
    ],
    liveLink: "https://n-youtube.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/n-youtube",
  },
  {
    uniqueID: "4",
    name: "The Fork",
    logo: "https://the-fork.netlify.app/theForklogo.1d5b4003.jpg",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss2.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss3.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss4.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss5.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss6.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss7.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss8.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/theFork-ss9.webp",
    ],
    description:
      "The Fork: Swiggy Clone is a ReactJS-based app replicating Swiggy's core features. Swiggy is India's leading food delivery application. The app allows users to browse top restaurants, view menus with real-time data from the Swiggy API. Key features include search with debouncing, restaurant filtering base on 4 selections, skeleton loading for smooth UX, and a dish carousel with live link to restaurant menu. Built with Redux, Tailwind CSS, and optimized for mobile, it offers a responsive and modern experience, hosted on Netlify.",
    tags: [
      "ReactJS",
      "Debouncing",
      "Tailwind CSS",
      "Skeleton UX",
      "Filtering with 4 options",
      "Netlify",
      "Swiggy API",
      "Redux Toolkit",
      "Carousel",
      "Real Time UI",
      "Cart Functionality",
      "React-Icons",
      "React Hooks",
    ],
    liveLink: "https://the-fork.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/n-react",
  },
  {
    uniqueID: "5",
    name: "GPT Flix",
    logo: "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production/consent/87b6a5c0-0104-4e96-a291-092c11350111/01938dc4-59b3-7b21-92dd-d4d4b93ad8a6/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/gptflix-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/gptflix-ss2.webp",
    ],
    description:
      "Work Under Progress.. It is a clone of our most favourite - Netflix - coden named as GPTFlix. It uses Google Firebase to handle login/logout feature. It will be AI powered to showcase and recommend top movies and webseries based on TMDB's API.",
    tags: [
      "ReactJS",
      "Redux Toolkit",
      "Google Firebase Auth",
      "TMDB API",
      "Open AI",
      "React Hooks",
      "Tailwind CSS",
      "React Router DOM",
      "React-Icons",
    ],
    codeLink: "https://github.com/nikhil-rawal/gpt-flix",
  },
  {
    uniqueID: "6",
    name: "Incredibles",
    logo: "https://incredibles.netlify.app/assets/svg/incredibles_logo.svg",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/incredibles-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/incredibles-ss2.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/incredibles-ss3.webp",
    ],
    description:
      "Incredibles is a ReactJS-based website for an overseas consultant business, designed to dynamically display data from Google Sheets. The website is hosted on Netlify and styled using Sass/SCSS, Bootstrap, and React Icons. It leverages the Papa Parse package to convert Google Sheets data into JSON and then into JSX, enabling easy content updates for the admin. This streamlined data flow allows the website to stay up-to-date with minimal effort while providing a modern, responsive experience. The website also provides a query page.",
    tags: [
      "ReactJS",
      "Dynamic Display Data",
      "SASS/SCSS",
      "Bootstrap",
      "React-Icons",
      "Netlify",
      "Google Sheets",
      "Query Page",
      "React Hooks",
    ],
    liveLink: "https://incredibles.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/Incredibles-Website",
  },
  {
    uniqueID: "7",
    name: "Wiindy - The Weather App",
    logo: "",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/wiindy-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/wiindy-ss2.webp",
    ],
    description:
      "Wiindy - The Weather App is a single-page weather application built with ReactJS and styled using SCSS. It provides detailed weather information, including current conditions, forecasts, and historical data, sourced from OpenWeatherMap and AccuWeather APIs. The app features efficient state management with React hooks, dynamic data handling using Axios, and responsive design for a seamless user experience. The goal is to empower users to access comprehensive weather data for any location with a simple search.",
    tags: [
      "ReactJS",
      "SCSS/SASS",
      "Weather App",
      "Current Conditions",
      "Forecasts",
      "Historical Data",
      "OpenWeather",
      "Accuweather",
      "React Hooks",
      "Axios",
      "Responsive Design",
      "Figma",
    ],
    liveLink: "https://wiindy.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/Wiindy--The-Weather-App",
  },
  {
    uniqueID: "8",
    name: "Random Paletter Generator",
    logo: "",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/palette-ss1.webp",
    ],
    description:
      "Random Palette Generator can be used to generate random palettes for our web apps.",
    tags: ["HTML", "CSS", "JavaScript", "Palette Generator"],
    liveLink: "https://randompalettegenerator.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/Random_Palette_Generator",
  },
  {
    uniqueID: "7",
    name: "Vanilla JS To-Do",
    logo: "",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/todo-ss1.webp",
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/todo-ss2.webp",
    ],
    description:
      "It is a simple Vanilla JavaScript based to-do app. We can add a list of tasks to be done, delete completed tasks, and toggle to view incompleted and completed tasks.",
    tags: ["HTML", "CSS", "JavaScript", "To-Do", "Toggle"],
    liveLink: "https://vanilla-js-to-do-list.netlify.app",
    codeLink: "https://github.com/nikhil-rawal/VanillaJS-ToDo",
  },
  {
    uniqueID: "9",
    name: "Covid-19 Form",
    logo: "",
    images: [
      "https://nikhil-portfolio-screenshots.s3.us-east-1.amazonaws.com/px-conversions/covidForm-ss1.webp",
    ],
    description:
      "Covid-19 test booking form is a replica form to book Covid-19 test online.",
    tags: ["HTML", "CSS", "JavaScript"],
    liveLink:
      "https://nikhil-rawal.github.io/Covid-19-Form-GroupProject-WebDev2/",
    codeLink:
      "https://github.com/nikhil-rawal/Covid-19-Form-GroupProject-WebDev2",
  },
];
